import React from "react";
import type { UserbackFeedbackType } from "@userback/widget";
import { openUserbackForm } from "@/lib/Userback";

export const UserbackFormButton: React.FC<{
  label: string;
  feedbackType: UserbackFeedbackType;
  className?: string;
}> = ({ label, feedbackType, className = "" }) => {
  return (
    <button
      type="button"
      onClick={() => void openUserbackForm(feedbackType)}
      className={`underline transition-colors duration-200 ${className}`}
    >
      {label}
    </button>
  );
};
